import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7dbbbbfc&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=tsx&"
export * from "./PopupDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./PopupDialog.scss?vue&type=style&index=0&id=7dbbbbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbbbbfc",
  null
  
)

export default component.exports